const DOCUMENT_TYPE = {
  QUOTE: {
    id: "QUOTE",
    labels: {
      nl: {
        singular: "Offerte",
        plural: "Offertes",
      },
      en: {
        singular: "Quote",
        plural: "Quotes",
      },
      fr: {
        singular: "Devis",
        plural: "Devis",
      },
    },
    CODE_ERP: "OFF",
    CODE_DIAS: "UITOFF",
    STATUSSES: {
      PENDING: {
        id: "PENDING",
        codes: [1],
        color: "INFO",
        label: {
          en: "Pending",
          nl: "Lopend",
          fr: "En attente",
        },
      },
      CONVERTED: {
        id: "CONVERTED",
        codes: [2],
        color: "SUCCESS",
        label: {
          en: "Converted",
          nl: "Verwerkt",
          fr: "Converti",
        },
      },
      CANCELLED: {
        id: "CANCELLED",
        codes: [3, 4],
        color: "DANGER",
        label: {
          en: "Cancelled",
          nl: "Geannuleerd",
          fr: "Annulé",
        },
      },
    },
  },
  ORDER: {
    id: "ORDER",
    labels: {
      nl: {
        singular: "Bestelling",
        plural: "Bestellingen",
      },
      en: {
        singular: "Order",
        plural: "Orders",
      },
      fr: {
        singular: "Commande",
        plural: "Commandes",
      },
    },
    CODE_ERP: "VKO",
    CODE_DIAS: "VKPORD",
    STATUSSES: {
      PENDING: {
        id: "PENDING",
        codes: [1],
        color: "INFO",
        label: {
          en: "Pending",
          nl: "Lopend",
          fr: "En attente",
        },
      },
      DELIVERED: {
        id: "DELIVERED",
        codes: [2],
        color: "SUCCESS",
        label: {
          en: "Delivered",
          nl: "Geleverd",
          fr: "Livré",
        },
      },
      INVOICED: {
        id: "INVOICED",
        codes: [3],
        color: "SUCCESS",
        label: {
          en: "Invoiced",
          nl: "Gefactureerd",
          fr: "Facturé",
        },
      },
    },
  },
  DELIVERY: {
    id: "DELIVERY",
    labels: {
      nl: {
        singular: "Leverbon",
        plural: "Leverbonnen",
      },
      en: {
        singular: "Delivery",
        plural: "Deliveries",
      },
      fr: {
        singular: "Livraison",
        plural: "Livraisons",
      },
    },

    CODE_ERP: "LVB",
    CODE_DIAS: "UITLEV",
    STATUSSES: {
      PENDING: {
        id: "PENDING",
        codes: [1],
        color: "INFO",
        label: {
          en: "Pending",
          nl: "Lopend",
          fr: "En attente",
        },
      },
      INVOICED: {
        id: "INVOICED",
        codes: [2],
        color: "SUCCESS",
        label: {
          en: "Invoiced",
          nl: "Gefactureerd",
          fr: "Facturé",
        },
      },
    },
  },
  INVOICE: {
    id: "INVOICE",
    labels: {
      nl: {
        singular: "Factuur",
        plural: "Facturen",
      },

      en: {
        singular: "Invoice",
        plural: "Invoices",
      },
      fr: {
        singular: "Facture",
        plural: "Factures",
      },
    },
    CODE_ERP: "FCT",
    CODE_DIAS: "VKPFCT",
    STATUSSES: {
      PENDING: {
        id: "PENDING",
        codes: [1],
        color: "INFO",
        label: {
          en: "Pending",
          nl: "Lopend",
          fr: "En attente",
        },
      },
      PROCESSED: {
        id: "PROCESSED",
        codes: [2],
        color: "SUCCESS",
        label: {
          en: "Processed",
          nl: "Verwerkt",
          fr: "Traité",
        },
      },
    },
  },
  REPAIR: {
    id: "REPAIR",
    labels: {
      nl: {
        singular: "Herstelbon",
        plural: "Herstelbonnen",
      },
    },
    CODE_ERP: "HRB",
    CODE_DIAS: "HRSTBON",
    STATUSSES: {
      PENDING: {
        id: "PENDING",
        codes: [1],
        color: "INFO",
        label: {
          en: "Pending",
          nl: "Lopend",
          fr: "En attente",
        },
      },
      DELIVERED: {
        id: "DELIVERED",
        codes: [2],
        color: "SUCCESS",
        label: {
          en: "Delivered",
          nl: "Geleverd",
          fr: "Livré",
        },
      },
      INVOICED: {
        id: "INVOICED",
        codes: [3],
        color: "SUCCESS",
        label: {
          en: "Invoiced",
          nl: "Gefactureerd",
          fr: "Facturé",
        },
      },
    },
  },
};

const DELIVERY_STATUS = {
  PICKUP: {
    id: "PICKUP",
    code: [3],
    color: "PRIMARY",
    labels: {
      nl: {
        singular: "Afhalen",
        plural: "Afhalingen",
      },
      en: {
        singular: "Pickup",
        plural: "Pickups",
      },
      fr: {
        singular: "Enlèvement",
        plural: "Enlèvements",
      },
    },
  },
  DELIVERY_AND_INSTALL: {
    id: "DELIVERY_AND_INSTALL",
    code: [1],
    color: "INFO",
    labels: {
      nl: {
        singular: "Leveren en plaatsen",
        plural: "Leveringen en plaatsingen",
      },
      en: {
        singular: "Deliver and install",
        plural: "Deliveries and installations",
      },
      fr: {
        singular: "Livrer et installer",
        plural: "Livraisons et installations",
      },
    },
  },
  DELIVERY: {
    id: "DELIVERY",
    code: [2],
    color: "INFO",
    labels: {
      nl: {
        singular: "Leveren",
        plural: "Leveringen",
      },
      en: {
        singular: "Delivery",
        plural: "Deliveries",
      },
      fr: {
        singular: "Livraison",
        plural: "Livraisons",
      },
    },
  },
  PICKUP_ASAMCO: {
    id: "PICKUP_ASAMCO",
    code: [4],
    color: "PRIMARY",
    labels: {
      nl: {
        singular: "Afhaling camion Asamco",
        plural: "Afhalingen camion Asamco",
      },
      en: {
        singular: "Pickup truck Asamco",
        plural: "Pickups truck Asamco",
      },
      fr: {
        singular: "Enlèvement camion Asamco",
        plural: "Enlèvements camion Asamco",
      },
    },
  },
  OWN_SERVICE_DELIVERY: {
    id: "OWN_SERVICE_DELIVERY",
    code: [5],
    color: "SUCCESS",
    labels: {
      nl: {
        singular: "Aflevering onze diensten",
        plural: "Afleveringen onze diensten",
      },
      en: {
        singular: "Delivery by our service",
        plural: "Deliveries by our service",
      },
      fr: {
        singular: "Livraison par nos services",
        plural: "Livraisons par nos services",
      },
    },
  },
  DIRECT_DELIVERY_LEV_KL: {
    id: "DIRECT_DELIVERY_LEV_KL",
    code: [6],
    color: "SUCCESS",
    labels: {
      nl: {
        singular: "Rechtstreekse levering LEV->KL",
        plural: "Rechtstreekse leveringen LEV->KL",
      },
      en: {
        singular: "Direct delivery LEV->KL",
        plural: "Direct deliveries LEV->KL",
      },
      fr: {
        singular: "Livraison directe LEV->KL",
        plural: "Livraisons directes LEV->KL",
      },
    },
  },
  REP_DELIVERY: {
    id: "REP_DELIVERY",
    code: [7],
    color: "WARNING",
    labels: {
      nl: {
        singular: "Levering VERTEGENWOORDIGER",
        plural: "Leveringen VERTEGENWOORDIGER",
      },
      en: {
        singular: "Delivery by representative",
        plural: "Deliveries by representative",
      },
      fr: {
        singular: "Livraison par représentant",
        plural: "Livraisons par représentant",
      },
    },
  },
  TECHNICIAN_DELIVERY: {
    id: "TECHNICIAN_DELIVERY",
    code: [8],
    color: "WARNING",
    labels: {
      nl: {
        singular: "Levering door technieker",
        plural: "Leveringen door technieker",
      },
      en: {
        singular: "Delivery by technician",
        plural: "Deliveries by technician",
      },
      fr: {
        singular: "Livraison par technicien",
        plural: "Livraisons par technicien",
      },
    },
  },
  CONTAINER_PICKUP: {
    id: "CONTAINER_PICKUP",
    code: [30],
    color: "SECONDARY",
    labels: {
      nl: {
        singular: "Container afhaling",
        plural: "Container afhalingen",
      },
      en: {
        singular: "Container pickup",
        plural: "Container pickups",
      },
      fr: {
        singular: "Enlèvement de conteneur",
        plural: "Enlèvements de conteneur",
      },
    },
  },
};

function getCodeDiasByDokType(dokType) {
  // doorloop alle documenttypes
  for (const key in DOCUMENT_TYPE) {
    const docType = DOCUMENT_TYPE[key];
    if (docType.CODE_ERP === dokType) {
      return docType.CODE_DIAS;
    }
  }
  return null; // niks gevonden
}

const ERPvsDIASdoctypes = {
  VKO: "VKPORD",
  OFF: "UITOFF",
  LVB: "UITLEV",
  FCT: "VKPFCT",
  AKO: "AKPORD",
  AKH: "AKPORDH",
  AKPS: ["AKPFCT", "AKPFTS"],
  PRA: "PRANVR",
  RET: "RTRBON",
  HRB: "HRSTBON",
  CRE: "AKPCRE",
  TRO: "TRPORD",
  COM: "AKPCRE",
};

const AWTECH = {
  ABCLVRNGSTP: {
    1: {
      name: "Productleverancier",
    },
    2: {
      name: "Dienstenleverancier",
    },
    3: {
      name: "Logistieke leverancier",
    },
    4: {
      name: "Facility leverancier",
    },
    5: {
      name: "IT leverancier",
    },
    6: {
      name: "Kantoor leverancier",
    },
    7: {
      name: "Productieleverancier Eigen",
    },
    8: {
      name: "Marketing leverancier",
    },
    9: {
      name: "Onderzoeksleverancier",
    },
    10: {
      name: "Fleet leverancier",
    },
    11: {
      name: "Interne leverancier",
    },
  },
  ContactCatTarif: {
    1: {
      description: "Kortinggroep 1",
      kortingtable: [0, 0, 0, 0, 3, 4, 6, 7, 8],
    },
    2: {
      description: "Kortinggroep 2",
      kortingtable: [0, 0, 1, 2, 8, 10, 13, 15, 18],
    },
    3: {
      description: "Kortinggroep 3",
      kortingtable: [0, 1, 3, 8, 13, 16, 18, 20, 23],
    },
    4: {
      description: "Kortinggroep 4",
      kortingtable: [1, 2, 8, 13, 20, 26, 33, 38, 48],
    },
    5: {
      description: "Scholen",
      kortingtable: [1, 3, 8, 13, 23, 31, 33, 38, 48],
    },
    6: {
      description: "Kortinggroep 6",
    },
    7: {
      description: "Kortinggroep 7",
    },
    levkorting: {
      description: "Lev korting",
      kortingsArr: [25, 27, 30, 35, 40, 45, 50, 60, 70],
    },
  },
  SageDocTypes: {
    verkoopDoc: {
      B: {
        description: "Bestelbon",
      },
      VL: {
        description: "Voorbereiding levering",
      },
      LB: {
        description: "Leveringsbon",
      },
      RET: {
        description: "Retourbon",
      },
      FB: {
        description: "Financ. tegoedbon",
      },
      VF: {
        description: "Factuur",
      },
      VCN: {
        description: "KN Retour",
      },
      VCF: {
        description: "KN Financieel",
      },
    },
    aankoopDoc: {
      PA: {
        description: "Prijsaanvraag",
      },
      ABV: {
        description: "Bestellingsvoorbereiding",
      },
      ABB: {
        description: "Bestelbon",
      },
      ALB: {
        description: "Leveringsbon",
      },
      AF: {
        description: "Retourbon",
      },
      FBA: {
        description: "Financ. tegoedbon",
      },
      ACN: {
        description: "KN Retour",
      },
      ACF: {
        description: "KN Financieel",
      },
    },
    voorraadDoc: {
      OPN: {
        description: "Opnamebeweging",
      },
      UIT: {
        description: "Uitgavebeweging",
      },
      WV: {
        description: "Waardevermindering",
      },
      TRA: {
        description: "Beweging transfer",
      },
      FVB: {
        description: "Fabricatievoorbereiding",
      },
      FO: {
        description: "Fabricatieorder",
      },
      PB: {
        description: "Fabricatiebon",
      },
    },
  },
  KPI: {
    Sales: {
      OK: {
        color: "success",
        icon: "fa-check",
        text: "Geen opmerking",
        class: "success-line",
        show: true,
        addManualTag: true,
      },
      HANDLEDOK: {
        color: "success",
        icon: "fa-file-circle-check",
        text: "Document verwerkt (marge OK)",
        class: "success-line",
        show: true,
      },
      HANDLEDNOK: {
        color: "danger",
        icon: "fa-file-circle-question",
        text: "Document verwerkt (marge NOK)",
        class: "danger-line",
        show: true,
      },
      WARRANTY: {
        color: "info",
        icon: "fa-shield",
        text: "Garantie",
        class: "action-line",
        show: true,
        addManualTag: true,
      },
      MOF: {
        color: "info",
        icon: "fa-wrench",
        text: "Montage / Opstart",
        class: "action-line",
        show: true,
        addManualTag: true,
      },
      HRF: {
        color: "info",
        icon: "fa-file-circle-question",
        text: "Herstelfiche",
        class: "action-line",
        show: true,
        addManualTag: true,
      },
      FORFREEFROMLEV: {
        color: "info",
        icon: "fa-gift",
        text: "Gratis van leverancier",
        class: "action-line",
        show: true,
        addManualTag: true,
      },
      PURCHASEPRNOK: {
        color: "info",
        icon: "fa-file-circle-question",
        text: "Aankoopbedrag gecorrigeerd",
        class: "action-line",
        show: true,
        addManualTag: true,
      },
      RETOUR: {
        color: "info",
        icon: "fa-undo",
        text: "Terugname",
        class: "action-line",
        show: true,
        addManualTag: true,
      },
      MANUEEL: {
        color: "info",
        icon: "fa-hand",
        text: "Manuele prijs",
        class: "manual-line",
        show: true,
        // This tag is derived from price calculation (auto/system),
        // so it should not be selectable/memorized as a manual action.
        addManualTag: false,
      },
      ARTPRICENOTOK: {
        color: "warning",
        icon: "fa-euro-sign",
        text: "Prijs artikel niet OK",
        class: "warning-line",
        show: true,
        addManualTag: true,
      },
      PRICEMANUALLOW: {
        color: "warning",
        icon: "fa-arrow-trend-down",
        text: "Prijs manueel laag ingezet",
        class: "warning-line",
        show: true,
        addManualTag: true,
      },
      IGNORE: {
        color: "secondary",
        icon: "fa-eye-slash",
        text: "Negeren op dashboard",
        class: "ignore-line",
        show: true,
        addManualTag: true,
      },
      INCOMPLETE_YOUNG: {
        color: "primary",
        icon: "fa-hourglass-half",
        text: "Onvolledig (<1 maand)",
        class: "action-line",
        show: true,
        addManualTag: false,
        description:
          "Geen gekoppelde/stockaankoop en geen gecontroleerde factuur (prijs_ok), jonger dan 1 maand",
      },
      INCOMPLETE_OLD: {
        color: "danger",
        icon: "fa-hourglass-end",
        text: "Onvolledig (>1 maand)",
        class: "danger-line",
        show: true,
        addManualTag: false,
        description:
          "Geen gekoppelde/stockaankoop en geen gecontroleerde factuur (prijs_ok), ouder dan 1 maand",
      },
      ITISSUE: {
        color: "warning",
        icon: "fa-bug",
        text: "IT issue",
        class: "warning-line",
        show: true,
        addManualTag: true,
      },
      CHECKAGAINLATER: {
        color: "info",
        icon: "fa-clock-rotate-left",
        text: "Later opnieuw controleren",
        class: "action-line",
        show: true,
        addManualTag: true,
      },
      REPAIR: {
        color: "info",
        icon: "fa-wrench",
        text: "Service",
        class: "action-line",
        show: true,
        description: "Herstelling",
      },
      INTERGROUP: {
        color: "primary",
        icon: "fa-building",
        text: "Intergroup",
        class: "action-line",
        show: true,
        addManualTag: false,
      },
      TEVEELKORTING: {
        color: "warning",
        icon: "fa-percent",
        text: "Hogere korting",
        class: "warning-line",
        show: true,
      },
      NEGATIEF: {
        color: "info",
        icon: "fa-rotate-left",
        text: "Negatieve lijnen",
        class: "action-line",
        show: true,
      },
      NEGATIEVEMARGE: {
        color: "danger",
        icon: "fa-file-circle-question",
        text: "Negatieve marge doc",
        class: "danger-line",
        show: true,
      },
      NEGATIEVEMARGELIJN: {
        color: "danger",
        icon: "fa-question",
        text: "Negatieve marge lijn",
        class: "danger-line",
        show: true,
      },
      LOWSTANDARDMARGIN: {
        color: "warning",
        icon: "fa-percent",
        text: "Lage standaard marge",
        class: "warning-line",
        show: true,
      },
      LOWCUSTOMMARGIN: {
        color: "warning",
        icon: "fa-percent",
        text: "Lage custom marge",
        class: "warning-line",
        show: true,
      },
      CUSTOMMARGINTHRESHOLD: {
        color: "info",
        icon: "fa-sliders",
        text: "Custom marge drempel",
        class: "action-line",
        show: true,
        description:
          "Minstens één regel met artikel-specifieke marge drempel (CMT)",
      },
      WRONGEHFCTDFAK: {
        color: "info",
        icon: "fa-question",
        text: "Factor VKO niet correct",
        class: "action-line",
        show: true,
      },
      DIFFPRICE: {
        color: "info",
        icon: "fa-question",
        text: "Prijs LVB ≠ VKO",
        class: "action-line",
        show: true,
      },
      WRONGEHFCTAKO: {
        color: "info",
        icon: "fa-question",
        text: "Factor AKO niet correct",
        class: "action-line",
        show: true,
      },
      ZSBZONDERAKO: {
        color: "info",
        icon: "fa-circle-xmark",
        text: "Geen AKO voor ZSB",
        class: "action-line",
        show: true,
      },
      ZSBZEROHOEV: {
        color: "info",
        icon: "fa-0",
        text: "ZSB met 0 stuks",
        class: "action-line",
        show: true,
      },
      KORTING100: {
        color: "warning",
        icon: "fa-percent",
        text: "100% korting",
        class: "problem-line",
        show: true,
        description: "lijn met 100% korting",
      },
      GEENAKBEDRAG: {
        color: "warning",
        icon: "fa-file-circle-question",
        text: "Geen aankoopbedrag",
        class: "warning-line",
        show: true,
      },
      FIREINTHEHOUSE: {
        color: "danger",
        icon: "fa-fire",
        text: "House on fire",
        class: "danger-line",
        show: true,
        addManualTag: true,
      },
      INFINITEFACTOR: {
        color: "danger",
        icon: "fa-infinity",
        text: "Factor oneindig",
        class: "danger-line",
        show: true,
      },
      ABSOLUTEVERKOOPKORTING: {
        color: "warning",
        icon: "fa-percent",
        text: "Absolute verkoopkorting",
        class: "warning-line",
        show: true,
      },
      ALLTYPESOFREVENUECHANGES: {
        color: "warning",
        icon: "fa-percent",
        text: "Alle types van verkoopkortingen",
        class: "warning-line",
        show: true,
      },
      SUPERMARGIN_POTENTIAL: {
        color: "info",
        icon: "fa-arrow-trend-up",
        text: "Super marge (potentieel)",
        class: "action-line",
        show: true,
        description:
          "MAK-prijs hoger dan originele lijstprijs; super marge nog niet per se gefactureerd",
      },
      SUPERMARGIN_ACHIEVED: {
        color: "success",
        icon: "fa-percent",
        text: "Super marge (behaald)",
        class: "success-line",
        show: true,
        description: "Gefactureerde omzet bereikt minstens het MAK-niveau",
      },
      NEGATIVEMAXMARGIN: {
        color: "danger",
        icon: "fa-file-circle-question",
        text: "Negatieve max. marge",
        class: "danger-line",
        show: true,
        description:
          "Originele lijstomzet ligt onder totale aankoopkost (max. marge negatief)",
      },
      ECOM: {
        color: "info",
        icon: "fa-globe",
        text: "ECOM",
        class: "action-line",
        show: true,
      },
      REVENUE0TO10: {
        color: "success",
        icon: "fa-euro-sign",
        text: "Revenue €0-€10",
        class: "success-line",
        show: true,
      },
      REVNUE10TO100: {
        color: "success",
        icon: "fa-euro-sign",
        text: "Revenue €10-€100",
        class: "success-line",
        show: true,
      },
      REVENUE100TO1000: {
        color: "success",
        icon: "fa-euro-sign",
        text: "Revenue €100-€1000",
        class: "success-line",
        show: true,
      },
      REVENUE1000TO10000: {
        color: "success",
        icon: "fa-euro-sign",
        text: "Revenue €1000-€10000",
        class: "success-line",
        show: true,
      },
      REVENUE10000TO100000: {
        color: "success",
        icon: "fa-euro-sign",
        text: "Revenue €10000-€100000",
        class: "success-line",
        show: true,
      },
      REVENUE100000TOINFINITY: {
        color: "success",
        icon: "fa-euro-sign",
        text: "Revenue €100000-∞",
        class: "warning-line",
        show: true,
      },
    },
  },
};

const WELDA = {
  ExtraFilter: {
    herintext: {
      Extern: {
        gebruikers: ["toca"],
      },
      Intern: {
        gebruikers: ["olho", "thvk", "jevh"],
      },
    },
  },
  Herstelstatussen: [
    {
      herststatus_nr: null,
      herststatus_naam: "Geen",
      kleur: "rgb(0, 191, 255)",
      tijd_groen: 7,
      tijd_oranje: 7,
      substatus: [
        {
          herstsubstatus_nr: null,
          herstsubstatus_naam: "Geen",
          gebruikers: ["bavo", "toma", "svds"],
        },
      ],
    },
    {
      herststatus_nr: 1,
      herststatus_naam: "Niet gestart",
      kleur: "rgb(0, 191, 255)",
      tijd_groen: 7,
      tijd_oranje: 7,
      substatus: [
        {
          herstsubstatus_nr: 0,
          herstsubstatus_naam: "Alles",
          gebruikers: ["bavo", "ken", "ruva", "svds", "thvk"],
        },
        {
          herstsubstatus_nr: 1,
          herstsubstatus_naam: "Las- en Plasmatoestel",
          gebruikers: ["olho", "joal", "jevh"],
        },
        {
          herstsubstatus_nr: 2,
          herstsubstatus_naam: "Gereedschap man. en elektr.",
          gebruikers: ["olho", "joal", "jevh"],
        },
        {
          herstsubstatus_nr: 3,
          herstsubstatus_naam: "Bewerkingsmachines metaal hout",
          gebruikers: ["joal", "olho", "jevh"],
        },
        {
          herstsubstatus_nr: 4,
          herstsubstatus_naam: "Toortsen Mig Tig Plasma",
          gebruikers: ["toma", "jevh"],
        },
        {
          herstsubstatus_nr: 5,
          herstsubstatus_naam: "Slijpdienst",
          gebruikers: [],
        },
        {
          herstsubstatus_nr: 6,
          herstsubstatus_naam: "Retour verhuur en op proef",
          gebruikers: ["olho", "jevh"],
        },
        {
          herstsubstatus_nr: 7,
          herstsubstatus_naam: "Opsturen leverancier",
          gebruikers: ["elge"],
        },
        {
          herstsubstatus_nr: 8,
          herstsubstatus_naam: "Lastafels en toebeh.",
          gebruikers: ["phal"],
        },
      ],
      __v: 0,
    },
    {
      herststatus_nr: 2,
      herststatus_naam: "In behandeling intern",
      kleur: "rgb(191, 0, 255)",
      tijd_groen: 7,
      tijd_oranje: 7,
      substatus: [
        {
          herstsubstatus_nr: 0,
          herstsubstatus_naam: "Alles",
          gebruikers: ["svds", "bavo", "ken", "ruva"],
        },
        {
          herstsubstatus_nr: 1,
          herstsubstatus_naam: "Bestek opmaken",
          gebruikers: [""],
        },
        {
          herstsubstatus_nr: 5,
          herstsubstatus_naam: "Bestek nakijken technieker",
          gebruikers: ["toma", "olho", "thvk", "jevh"],
        },
        {
          herstsubstatus_nr: 10,
          herstsubstatus_naam: "Wachten kl. Onherstelbaar bestek",
          gebruikers: ["elge"],
        },
        {
          herstsubstatus_nr: 15,
          herstsubstatus_naam: "Wachten kl. Herstelbaar bestek",
          gebruikers: ["elge"],
        },
        {
          herstsubstatus_nr: 20,
          herstsubstatus_naam: "Antwoord klant - mag hersteld worden",
          gebruikers: ["olho", "thvk", "jevh"],
        },
        {
          herstsubstatus_nr: 25,
          herstsubstatus_naam: "Antwoord klant - niet herstellen",
          gebruikers: [""],
        },
        {
          herstsubstatus_nr: 30,
          herstsubstatus_naam: "Stukken bestellen / Prijsaanvraag",
          gebruikers: [],
        },
        {
          herstsubstatus_nr: 35,
          herstsubstatus_naam: "Wachten op stukken",
          gebruikers: ["elge", "olho", "thvk", "jevh"],
        },
        {
          herstsubstatus_nr: 40,
          herstsubstatus_naam: "Stukken binnengekomen wacht op actie tec.",
          gebruikers: ["olho", "joal", "thvk", "jevh"],
        },
        {
          herstsubstatus_nr: 45,
          herstsubstatus_naam: "Verder opvolging nodig",
          gebruikers: ["olho", "joal", "thvk", "jevh"],
        },
      ],
      __v: 0,
    },
    {
      herststatus_nr: 4,
      herststatus_naam: "In behandeling Leverancier",
      kleur: "rgb(255, 122, 0)",
      tijd_groen: 7,
      tijd_oranje: 7,
      substatus: [
        {
          herstsubstatus_nr: 0,
          herstsubstatus_naam: "Alles",
          gebruikers: ["svds", "bavo", "ken", "ruva", "bena"],
        },
        {
          herstsubstatus_nr: 5,
          herstsubstatus_naam: "Klaar voor verzending",
          gebruikers: [""],
        },
        {
          herstsubstatus_nr: 10,
          herstsubstatus_naam: "Verzonden",
          gebruikers: ["elge"],
        },
        {
          herstsubstatus_nr: 15,
          herstsubstatus_naam: "Wachten kl. Onherstelbaar bestek",
          gebruikers: ["elge"],
        },
        {
          herstsubstatus_nr: 20,
          herstsubstatus_naam: "Wachten kl. Herstelbaar bestek",
          gebruikers: ["elge"],
        },
        {
          herstsubstatus_nr: 25,
          herstsubstatus_naam: "Antwoord kl. mag hersteld worden",
          gebruikers: [""],
        },
        {
          herstsubstatus_nr: 30,
          herstsubstatus_naam: "Antwoord kl. niet herstellen",
          gebruikers: [""],
        },
        {
          herstsubstatus_nr: 35,
          herstsubstatus_naam: "Verdere opvolging nodig",
          gebruikers: [""],
        },
      ],
      __v: 0,
    },
    {
      herststatus_nr: 10,
      herststatus_naam: "Hersteld/Niet hersteld",
      kleur: "rgb(135, 55, 255)",
      tijd_groen: 7,
      tijd_oranje: 7,
      substatus: [
        {
          herstsubstatus_nr: 0,
          herstsubstatus_naam: "Alles",
          gebruikers: ["svds", "ken", "ruva", "bena"],
        },
        {
          herstsubstatus_nr: 1,
          herstsubstatus_naam: "Hersteld",
          gebruikers: ["bavo"],
        },
        {
          herstsubstatus_nr: 2,
          herstsubstatus_naam: "Onhersteld terug",
          gebruikers: ["elge", "bavo"],
        },
        {
          herstsubstatus_nr: 3,
          herstsubstatus_naam: "Niet hersteld",
          gebruikers: ["bavo", "jevh"],
        },
        {
          herstsubstatus_nr: 4,
          herstsubstatus_naam: "Te verwittigen",
          gebruikers: ["elge"],
        },
        {
          herstsubstatus_nr: 5,
          herstsubstatus_naam: "Verwittigd",
          gebruikers: ["bavo"],
        },
        {
          herstsubstatus_nr: 6,
          herstsubstatus_naam: "Te Vernietigen",
          gebruikers: ["toma"],
        },
        {
          herstsubstatus_nr: 7,
          herstsubstatus_naam: "Recup",
          gebruikers: ["toma"],
        },
        {
          herstsubstatus_nr: 8,
          herstsubstatus_naam: "Vernietigd/Recuped",
          gebruikers: ["bavo"],
        },
      ],
      __v: 0,
    },
    {
      herststatus_nr: 15,
      herststatus_naam: "Geleverd",
      kleur: "rgb(0, 106, 82)",
      tijd_groen: 0,
      tijd_oranje: 0,
      substatus: [
        {
          herstsubstatus_nr: 0,
          herstsubstatus_naam: "Alles",
          gebruikers: [""],
        },
        {
          herstsubstatus_nr: 1,
          herstsubstatus_naam: "Geleverd",
          gebruikers: [""],
        },
      ],
      __v: 0,
    },
    {
      herststatus_nr: 20,
      herststatus_naam: "Uitgerekend",
      kleur: "rgb(135, 37, 82)",
      tijd_groen: 28,
      tijd_oranje: 14,
      substatus: [
        {
          herstsubstatus_nr: 0,
          herstsubstatus_naam: "Alles",
          gebruikers: [""],
        },
        {
          herstsubstatus_nr: 3,
          herstsubstatus_naam: "Uitgerekend",
          gebruikers: ["svds", "bavo", "ken", "ruva", "bena"],
        },
      ],
      __v: 0,
    },
  ],
  facturatieregime: [
    {
      Number: 0,
      Description: "Geen regime",
    },
    {
      Number: 1,
      Description: "Wekelijkse facturatie",
    },
    {
      Number: 2,
      Description: "14 daagse facturatie",
    },
    {
      Number: 3,
      Description: "Maandelijkse facturatie",
    },
  ],
  Transporteurs: {
    GLS: {
      trackingURL: "https://gls-group.eu/BE/vl/pakket-volgen?match=",
    },
  },
  KPI: {
    LopendeHRB: {
      TOTALISZERO: {
        color: "danger",
        icon: "fa-circle-exclamation",
        text: "Totaal nul",
        class: "danger-line",
        show: true,
      },
      TODOTECH: {
        color: "success",
        icon: "fa-screwdriver-wrench",
        text: "Wachten actie technieker",
        class: "success-line",
        show: true,
      },
      TODOLEV: {
        color: "success",
        icon: "fa-industry",
        text: "Wachten actie leverancier",
        class: "success-line",
        show: true,
      },
      TODOCUST: {
        color: "success",
        icon: "fa-crown",
        text: "Wachten actie klant",
        class: "success-line",
        show: true,
      },
      TODOADMIN: {
        color: "success",
        icon: "fa-computer",
        text: "Wachten actie admin",
        class: "success-line",
        show: true,
      },
      AKONOTSENDED: {
        color: "danger",
        icon: "fa-hourglass-half",
        text: "VKO met gelinkte niet verzonden AKO",
        class: "danger-line",
        show: true,
      },
      WAITAKO: {
        color: "info",
        icon: "fa-truck-arrow-right",
        text: "wachten aanlevering",
        class: "action-line",
        show: true,
      },
      NOTHERE: {
        color: "warning",
        icon: "fa-house-circle-exclamation",
        text: "moet binnen zijn?",
        class: "warning-line",
        show: true,
      },
      NOTORDERED: {
        color: "danger",
        icon: "fa-bell",
        text: "niet besteld!?",
        class: "danger-line",
        show: true,
      },
      NOCONFIRMATION: {
        color: "warning",
        icon: "fa-calendar-check",
        text: "AK niet bevestigd",
        class: "warning-line",
        show: true,
      },
      NOSERFICHE: {
        color: "danger",
        icon: "fa-ghost",
        text: "Geen fiche op HRB",
        class: "danger-line",
        show: true,
      },
      PARTPAID: {
        color: "info",
        icon: "fa-coins",
        text: "deels betaald",
        class: "action-line",
        show: true,
      },
      NOTPAID: {
        color: "warning",
        icon: "fa-coins",
        text: "niet betaald",
        class: "warning-line",
        show: true,
      },
      NOTFINISHED: {
        color: "warning",
        icon: "fa-user-clock",
        text: "Taak niet correct",
        class: "warning-line",
        show: true,
      },
      NOPROFORMA: {
        color: "warning",
        icon: "fa-clipboard-question",
        text: "Geen betaalvoorstel/proforma",
        class: "warning-line",
        show: true,
      },
    },
    LopendeVKO: {
      TODELIVER: {
        color: "success",
        icon: "fa-truck-ramp-box",
        text: "kan verzonden/afgehaald worden",
        class: "success-line",
        show: true,
      },
      TODELIVERLASTAFEL: {
        color: "success",
        icon: "fa-table-cells",
        text: "kan verzonden/afgehaald worden LASTAFELS",
        class: "success-line",
        show: true,
      },
      TODELIVERWELDA: {
        color: "success",
        icon: "fa-truck",
        text: "Verzenden eigen diensten",
        class: "success-line",
        show: true,
      },
      TODELIVERWELDAGLS: {
        color: "success",
        icon: "fa-truck",
        text: "Verzenden vanuit Welda via GLS",
        class: "success-line",
        show: true,
      },
      TODELIVERVERT: {
        color: "success",
        icon: "fa-people-group",
        text: "Klaar levering vertegenwoordiger",
        class: "success-line",
        show: true,
      },
      TODELIVERSERVICE: {
        color: "success",
        icon: "fa-calculator",
        text: "Uitleveren service",
        class: "success-line",
        show: true,
      },
      TODELIVERPART: {
        color: "primary",
        icon: "fa-box-open",
        text: "kan deels verzonden/afgehaald worden",
        class: "primary-line",
        show: true,
      },
      TOPICK: {
        color: "primary",
        icon: "fa-dolly",
        text: "kan gepikt worden",
        class: "primary-line",
        show: true,
      },
      PARTPAID: {
        color: "info",
        icon: "fa-coins",
        text: "deels betaald",
        class: "action-line",
        show: true,
      },
      NOTPAID: {
        color: "warning",
        icon: "fa-coins",
        text: "niet betaald",
        class: "warning-line",
        show: true,
      },
      NOTFULLYPAID: {
        color: "danger",
        icon: "fa-hand-holding-dollar",
        text: "Niet volledig betaald",
        class: "problem-line",
        show: true,
        description:
          "Betalingsconditie vereist voorafbetaling/contant en som betalingen < totaal incl. btw",
      },
      NOTHERE: {
        color: "warning",
        icon: "fa-house-circle-exclamation",
        text: "moet binnen zijn?",
        class: "warning-line",
        show: true,
      },
      NOTORDERED: {
        color: "danger",
        icon: "fa-bell",
        text: "niet besteld!?",
        class: "danger-line",
        show: true,
      },
      NOCONFIRMATION: {
        color: "warning",
        icon: "fa-calendar-check",
        text: "AK niet bevestigd",
        class: "warning-line",
        show: true,
      },
      AKONOTSENDED: {
        color: "danger",
        icon: "fa-hourglass-half",
        text: "VKO met gelinkte niet verzonden AKO",
        class: "danger-line",
        show: true,
      },
      WAITSERVICE: {
        color: "info",
        icon: "fa-wrench",
        text: "wachten service",
        class: "action-line",
        show: true,
      },
      NOPROFORMA: {
        color: "warning",
        icon: "fa-clipboard-question",
        text: "Geen betaalvoorstel/proforma",
        class: "warning-line",
        show: true,
      },
      NOSERFICHE: {
        color: "danger",
        icon: "fa-ghost",
        text: "Geen fiche op HRB",
        class: "danger-line",
        show: true,
      },
      WAITAKO: {
        color: "info",
        icon: "fa-truck-arrow-right",
        text: "wachten aanlevering",
        class: "action-line",
        show: true,
      },
      WAITRETURN: {
        color: "info",
        icon: "fa-rotate-left",
        text: "wachten retour",
        class: "action-line",
        show: true,
      },
      NEARDELIVER: {
        color: "info",
        icon: "fa-circle-notch",
        text: "Binnenkort leveren!",
        class: "action-line",
        show: true,
      },
      WAITDELIVER: {
        color: "warning",
        icon: "fa-pause",
        text: "nog niet leveren",
        class: "action-line",
        show: true,
      },
      NOTDELIVERED: {
        color: "danger",
        icon: "fa-clipboard-question",
        text: "Niet geleverd!",
        class: "danger-line",
        show: true,
      },
      RENTALATCUSTOMER: {
        color: "info",
        icon: "fa-circle-notch",
        text: "Verhuur bij klant",
        class: "action-line",
        show: true,
      },
      TO0MANYNOTIFICATIONS: {
        color: "danger",
        icon: "fa-comment-sms",
        text: "Teveel herinneringen",
        class: "danger-line",
        show: true,
      },
      NOFCTREF: {
        color: "danger",
        icon: "fa-asterisk",
        text: "Referentie nazien",
        class: "problem-line",
        show: true,
        description: "Klantverplichte referentie",
      },
    },
    FinanceLVB: {
      OKTOFCT: {
        color: "success",
        icon: "fa-file-circle-check",
        text: "OK voor facturatie",
        class: "action-line",
        show: true,
        description:
          "Deze LVB's voldoen aan alle voorwaarden om gefactureerd te worden",
      },
      APPROVEDTOFCT: {
        color: "success",
        icon: "fa-thumbs-up",
        text: "Goedgekeurd voor facturatie",
        class: "action-line",
        show: true,
      },
      GROUP: {
        color: "info",
        icon: "fa-layer-group",
        text: "Groeperen?",
        class: "action-line",
        show: true,
        description:
          "Klant heeft verschillende LVB's die kunnen gegroepeerd worden waarvan bons met nul of negatief bedrag",
      },
      VKOPGLV: {
        color: "info",
        icon: "fa-list-check",
        text: "VKO niet volledige uitgeleverd",
        class: "problem-line",
        show: true,
      },
      PRIJSNOK: {
        color: "warning",
        icon: "fa-euro-sign",
        text: "Prijs niet OK",
        class: "problem-line",
        show: true,
      },
      EMPTY: {
        color: "warning",
        icon: "fa-ghost",
        text: "Geen lijnen op LVB",
        class: "problem-line",
        show: true,
      },
      EMPTYBET: {
        color: "danger",
        icon: "fa-circle-exclamation",
        text: "Lege LVB met betaling",
        class: "problem-line",
        show: true,
      },
      PAIDLESSTHANTOTAL: {
        color: "danger",
        icon: "fa-scale-unbalanced",
        text: "Niet betaald",
        class: "problem-line",
        show: true,
        description:
          "Betalingsconditie is Kontant of tegen voorafbetaling, geen betalingen terwijl totaal incl. btw > 0",
      },
      PARTIALPAYMENT: {
        color: "warning",
        icon: "fa-coins",
        text: "Gedeeltelijk betaald",
        class: "problem-line",
        show: true,
        description:
          "Er zijn betalingen, maar de som is lager dan totaal incl. btw",
      },
      OVERPAID: {
        color: "danger",
        icon: "fa-arrow-trend-up",
        text: "Te veel betaald",
        class: "problem-line",
        show: true,
        description:
          "Som van Betalingen (hkas) is hoger dan totaal incl. btw",
      },
      NULLEURO: {
        color: "warning",
        icon: "fa-0",
        text: "LVB zonder bedrag",
        class: "problem-line",
        show: true,
        description: "LVB met bedrag 0EUR",
      },
      CREDIT: {
        color: "warning",
        icon: "fa-circle-minus",
        text: "Negatieve lijn",
        class: "problem-line",
        show: true,
        description: "LVB met negatief bedrag op lijn",
      },
      OTHERDOKTYPE: {
        color: "warning",
        icon: "fa-file-circle-question",
        text: "DEMO / OP PROEF? ",
        class: "problem-line",
        show: true,
        description: "LVB gemaakt vanuit een ander documenttype dan VKO OF HRB",
      },
      KORTING100: {
        color: "warning",
        icon: "fa-percent",
        text: "100% korting",
        class: "problem-line",
        show: true,
        description: "lijn met 100% korting",
      },
      OTHERSOORT: {
        color: "info",
        icon: "fa-file-circle-exclamation",
        text: "Andere Soort",
        class: "problem-line",
        show: true,
        description: "NTF, BLK, FMR,... anders dan none",
      },
      NOFCTREF: {
        color: "danger",
        icon: "fa-asterisk",
        text: "Referentie nazien",
        class: "problem-line",
        show: true,
        description: "Klantverplichte referentie",
      },
      COUPON: {
        color: "info",
        icon: "fa-receipt",
        text: "Waardebon/Voucher",
        class: "problem-line",
        show: true,
        description:
          'Alle LVB\'s met een artikel in Artikelgroep "CADEAU/WAARDEBON"',
      },
      RENTAL: {
        color: "info",
        icon: "fa-retweet",
        text: "Verhuur",
        class: "action-line",
        show: true,
      },
      WAITSERVICE: {
        color: "info",
        icon: "fa-wrench",
        text: "Service",
        class: "action-line",
        show: true,
        description:
          "Prijs niet OK van herstelling, na te kijken door service.",
      },
      ASAMCO: {
        color: "primary",
        icon: "fa-store",
        text: "ASAMCO",
        class: "",
        show: true,
      },
      IC: {
        color: "primary",
        icon: "fa-building",
        text: "Inter company",
        class: "",
        show: true,
      },
    },
    FinanceFCT: {
      NEGATIEF: {
        color: "info",
        icon: "fa-circle-minus",
        text: "Negatief bedrag",
        class: "action-line",
        show: true,
        description: "",
      },
      "%2": {
        color: "info",
        icon: "fa-percent",
        text: "2% openstaand",
        class: "action-line",
        show: true,
        description: "",
      },
    },
    FinanceDocTags: {
      EARLY_BIRD_REDUCTION: {
        key: "EARLY_BIRD_REDUCTION",
        color: "warning",
        icon: "fa-percent",
        text: "early bird reduction",
        class: "action-line",
        show: true,
        description: "Early bird reduction",
      },
      SALDO_NEGATIEF: {
        key: "SALDO_NEGATIEF",
        color: "info",
        icon: "fa-circle-minus",
        text: "Negatief saldo",
        class: "action-line",
        show: true,
      },
      SALDO_POSITIEF: {
        key: "SALDO_POSITIEF",
        color: "success",
        icon: "fa-circle-plus",
        text: "Positief saldo",
        class: "action-line",
        show: true,
      },
      SALDO_NUL: {
        key: "SALDO_NUL",
        color: "warning",
        icon: "fa-circle-zero",
        text: "Nul saldo",
        class: "action-line",
        show: true,
      },
      TOTAAL_NEGATIEF: {
        key: "TOTAAL_NEGATIEF",
        color: "info",
        icon: "fa-circle-minus",
        text: "Negatief totaal",
        class: "action-line",
        show: true,
      },
      TOTAAL_POSITIEF: {
        key: "TOTAAL_POSITIEF",
        color: "success",
        icon: "fa-circle-plus",
        text: "Positief totaal",
        class: "action-line",
        show: true,
      },
      TOTAAL_NUL: {
        key: "TOTAAL_NUL",
        color: "warning",
        icon: "fa-circle-zero",
        text: "Nul totaal",
        class: "action-line",
        show: true,
      },
      LT_TWO_PERCENT_NEGATIEF: {
        key: "LT_TWO_PERCENT_NEGATIEF",
        color: "info",
        icon: "fa-percent",
        text: "[-∞, -2]% Saldo negatief",
        class: "action-line",
        show: true,
        description: "",
      },
      GT_TWO_PERCENT_NEGATIEF: {
        key: "GT_TWO_PERCENT_NEGATIEF",
        color: "info",
        icon: "fa-percent",
        text: "[-2, 0]% Saldo negatief",
        class: "action-line",
        show: true,
        description: "",
      },
      LT_TWO_PERCENT_POSITIEF: {
        key: "LT_TWO_PERCENT_POSITIEF",
        color: "success",
        icon: "fa-percent",
        text: "[0, 2]% Saldo positief",
        class: "action-line",
        show: true,
        description: "",
      },
      GT_TWO_PERCENT_POSITIEF: {
        key: "GT_TWO_PERCENT_POSITIEF",
        color: "success",
        icon: "fa-percent",
        text: "[2, ∞]% Saldo positief",
        class: "action-line",
        show: true,
        description: "",
      },

      MAG_BETAALD_WORDEN: {
        key: "MAG_BETAALD_WORDEN",
        color: "success",
        icon: "fa-coins",
        text: "Mag betaald worden",
        class: "action-line",
        show: true,
        description: "",
      },
      NOG_NIET_GECONTROLEERD: {
        key: "NOG_NIET_GECONTROLEERD",
        color: "warning",
        icon: "fa-circle-question",
        text: "Nog niet gecontroleerd",
        class: "action-line",
        show: true,
        description: "",
      },
      BETAAL_NU_VOOR_KORTING: {
        key: "BETAAL_NU_VOOR_KORTING",
        color: "success",
        icon: "fa-clock",
        text: "Betaal nu voor korting",
        class: "action-line",
        show: true,
        description: "Vandaag nog voor kortingsdatum betalen",
      },
      BETAAL_VOOR_VERVAL: {
        key: "BETAAL_VOOR_VERVAL",
        color: "info",
        icon: "fa-calendar-check",
        text: "Betaal voor verval",
        class: "action-line",
        show: true,
        description: "Betalen tussen 7 dagen voor vervaldatum en vervaldatum",
      },
      BETALING_UITSTELLEN: {
        key: "BETALING_UITSTELLEN",
        color: "warning",
        icon: "fa-calendar-minus",
        text: "Betaling uitstellen",
        class: "action-line",
        show: true,
        description: "Betaling uitstellen tot 7 dagen voor vervaldatum",
      },
      BETALEN_REEDS_VERVALEN: {
        key: "BETALEN_REEDS_VERVALEN",
        color: "danger",
        icon: "fa-triangle-exclamation",
        text: "Betalen reeds vervallen",
        class: "action-line",
        show: true,
        description: "Factuur is reeds vervallen",
      },
    },
    logisticDispatching: {
      TODELIVER: {
        color: "success",
        icon: "fa-truck-ramp-box",
        text: "kan verzonden worden",
        count: 0,
        show: true,
      },
      TOPICK: {
        color: "success",
        icon: "fa-dolly",
        text: "kan gepikt worden",
        count: 0,
        show: true,
      },
      PARTPAID: {
        color: "info",
        icon: "fa-coins",
        text: "deels betaald",
        count: 0,
        show: false,
      },
      NOTPAID: {
        color: "warning",
        icon: "fa-coins",
        text: "niet betaald",
        count: 0,
        show: true,
      },
      NOTHERE: {
        color: "warning",
        icon: "fa-house-circle-exclamation",
        text: "moet binnen zijn?",
        count: 0,
        show: true,
      },
      NOTORDERED: {
        color: "danger",
        icon: "fa-bell",
        text: "niet besteld!?",
        count: 0,
        show: true,
      },
      WAITSERVICE: {
        color: "info",
        icon: "fa-wrench",
        text: "wachten service",
        count: 0,
        show: true,
      },
      WAITAKO: {
        color: "info",
        icon: "fa-truck-arrow-right",
        text: "wachten aanlevering",
        count: 0,
        show: true,
      },
    },
  },
  isOpenDays: false,
  coordinaten: {
    AD_LAT: 51.083542,
    AD_LON: 3.791838,
  },
  verlofdagen: [
    {
      date: "1/1/25",
      format: "MM/DD/YY",
      comment: "Nieuwjaarsdag",
    },
    {
      date: "4/20/25",
      format: "MM/DD/YY",
      comment: "Pasen",
    },
    {
      date: "4/21/25",
      format: "MM/DD/YY",
      comment: "Paasmaandag",
    },
    {
      date: "5/1/25",
      format: "MM/DD/YY",
      comment: "Dag van de Arbeid",
    },
    {
      date: "5/2/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "5/29/25",
      format: "MM/DD/YY",
      comment: "O.H. Hemelvaart",
    },
    {
      date: "5/30/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "6/8/25",
      format: "MM/DD/YY",
      comment: "Pinksteren",
    },
    {
      date: "6/9/25",
      format: "MM/DD/YY",
      comment: "Pinkstermaandag",
    },
    {
      date: "7/21/25",
      format: "MM/DD/YY",
      comment: "Nationale Feestdag",
    },
    {
      date: "7/22/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "7/23/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "7/24/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "7/25/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "7/28/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "7/29/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "7/30/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "7/31/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "8/1/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "8/15/25",
      format: "MM/DD/YY",
      comment: "O.L.V. Hemelvaart",
    },
    {
      date: "11/1/25",
      format: "MM/DD/YY",
      comment: "Allerheiligen",
    },
    {
      date: "11/10/25",
      format: "MM/DD/YY",
      comment: "Verplaatste feestdag",
    },
    {
      date: "11/11/25",
      format: "MM/DD/YY",
      comment: "Wapenstilstand",
    },
    {
      date: "12/25/25",
      format: "MM/DD/YY",
      comment: "Kerstmis",
    },
    {
      date: "12/26/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "12/29/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "12/30/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "12/31/25",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
    {
      date: "1/1/26",
      format: "MM/DD/YY",
      comment: "Nieuwjaarsdag",
    },
    {
      date: "1/2/26",
      format: "MM/DD/YY",
      comment: "Vaste verlofdag",
    },
  ],
};

// NOTE: These functions exist because there is a mismatch between the dossier number for AWTech in DIAS vs FinERP

const getWorkspaceFromDossierNr = (dossierNr) => {
  if (parseInt(dossierNr) === 70) {
    return 21;
  }
  return dossierNr;
};

const getDossierNrFromWorkspace = (workspace) => {
  if (parseInt(workspace) === 21) {
    return 70;
  }
  return workspace;
};

//#TODO SVEN OR SAM: ADD FINANCE DOC TAGS WHEN AVAILABLE IN WELDA KPI
const FINANCE_DOC_TAGS = WELDA.KPI.FinanceDocTags || {};

module.exports = {
  DOCUMENT_TYPE,
  DELIVERY_STATUS,
  getCodeDiasByDokType,
  ERPvsDIASdoctypes,
  FINANCE_DOC_TAGS,
  KPI: WELDA.KPI,
  WELDA,
  AWTECH,
  getWorkspaceFromDossierNr,
  getDossierNrFromWorkspace,
};
